import { useEffect, useState } from 'react';
import { createOrder } from '../services/orderService'

export const useOrder = () => {
    const [order, setOrder] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postOrder = async (data) => {
        setLoading(true);
        try {
            const response = await createOrder(data);
            setOrder([...order, response.data]);
            return response.data
        } catch (err) {
            setError('Failed to post Order');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        
    }, []);

    return { order, loading, error, alert, postOrder};
}